import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const CompareResults = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/tools/compare-cars');
  };

  return (
    <div className="min-h-screen bg-white pb-20">
      {/* Header */}
      <div className="bg-white border-b" style={{ borderBottomColor: '#E5E7EB' }}>
        <div className="max-w-screen-sm mx-auto px-4 py-4">
          <div className="flex items-center justify-between mb-3">
            <button
              onClick={handleBack}
              className="flex items-center gap-2 hover:opacity-70 transition-opacity"
              style={{ color: '#0B1221' }}
            >
              <ArrowLeft className="w-5 h-5" />
              <span className="font-medium">Back</span>
            </button>
            <span className="text-sm font-semibold tracking-wide">
              <span style={{ color: '#001F3F' }}>VINdicated.</span>
              <span style={{ color: '#FF4136' }}>ai</span>
            </span>
          </div>
          
          <h1 className="text-2xl font-extrabold tracking-tight" style={{ color: '#001F3F' }}>
            Compare results
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-screen-sm mx-auto px-4 py-6 space-y-6">
        <div className="rounded-xl p-6 text-center" style={{ backgroundColor: '#F9FAFB', border: '1px solid #E5E7EB' }}>
          <p className="text-sm leading-relaxed" style={{ color: '#6B7280' }}>
            Compare results will appear here once the analysis feature is fully implemented.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CompareResults;
